<script>
	import { page } from '$app/stores';

	let showError = false; 

	const statusText = new Map([
		[400, 'Bad request'],
		[404, 'Sorry, this page could not be found'],
		[403, 'Sorry, you dont have permission to view this page']
	]);

</script>


<div class="w-full bg-white text-center p-20">

	<div class="m-[1rem]">

		<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
			 class="w-[12rem] h-[12rem] mx-auto">
			<path stroke-linecap="round" stroke-linejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z" />
		</svg>
	</div>

	<div class="m-[1rem]">

		<h1 class="text-5xl font-thin">{$page.status}</h1>

		<h2 class="text-3xl">
			{statusText.get($page.status) ?? 'Something went wrong when loading this page, please try again later'}
			<button class:hidden={$page.status < 500 } class="cursor-pointer shadow-sm font-bold" on:click={() => showError = !showError }>&#9432; </button>
		</h2>

		<p class:hidden={!showError} class="font-thin text-red-500 mt-1">Error: {$page?.error?.message ?? "unknown"}</p>
	</div>
	<p class="">

		<a data-sveltekit-reload href="/" class="text-black rounded-md underline">Take Me Home</a>
	</p>
</div>
